import { Field } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import TextInput from 'src/components/input/TextInput';
import InputField from 'src/components/input/InputField';
import { FormValues } from '../form/FormValues';

export default function VatNumber() {
  const {
    register,
    trigger,
    formState: { errors },
  } = useFormContext<FormValues>();

  return (
    <InputField
      id="vatNumber"
      mb="0.5rem"
      errorMessage={String(errors.vatNumber?.message)}
      invalid={!!errors.vatNumber}
    >
      <Field.Label htmlFor="vatNumber">VAT number</Field.Label>
      <TextInput
        {...register('vatNumber')}
        id="vatNumber"
        inputGroupProps={{ height: 'unset' }}
        onBlur={() => trigger('vatNumber')}
      />
    </InputField>
  );
}
